import React from 'react';

const base = 'w-full bg-[#F7F8FA] border border-gray-200 rounded-lg px-3 py-2.5 text-[#1A1A2E] text-sm focus:outline-none focus:border-[#F57C20] focus:ring-1 focus:ring-[#F57C20]';

export const Field = ({ label, children, className = '' }) => (
  <label className={`block ${className}`}>
    <span className="block text-[#6B7280] text-[10px] font-bold uppercase tracking-wider mb-1.5">{label}</span>
    {children}
  </label>
);

export const TextInput = ({ testid, ...props }) => <input data-testid={testid} className={base} {...props} />;

export const SelectInput = ({ testid, children, ...props }) => (
  <select data-testid={testid} className={`${base} cursor-pointer`} {...props}>{children}</select>
);

export const Stepper = ({ testid, value, onChange, min = 0, max = 30, label, hint }) => (
  <div className="flex items-center justify-between gap-3 py-2">
    <div className="min-w-0">
      <p className="text-sm text-[#1A1A2E] font-medium">{label}</p>
      {hint && <p className="text-[11px] text-[#6B7280]">{hint}</p>}
    </div>
    <div className="flex items-center gap-2 flex-shrink-0">
      <button type="button" data-testid={`${testid}-minus`} onClick={() => onChange(Math.max(min, value - 1))}
        className="w-8 h-8 rounded-full border border-gray-300 text-[#1A1A2E] hover:border-[#F57C20] hover:text-[#F57C20] transition-colors">−</button>
      <span data-testid={`${testid}-value`} className="w-6 text-center text-sm font-semibold">{value}</span>
      <button type="button" data-testid={`${testid}-plus`} onClick={() => onChange(Math.min(max, value + 1))}
        className="w-8 h-8 rounded-full border border-gray-300 text-[#1A1A2E] hover:border-[#F57C20] hover:text-[#F57C20] transition-colors">+</button>
    </div>
  </div>
);

export const Section = ({ title, admin, children }) => (
  <div className="border-t border-gray-100 pt-4">
    <p className="text-[11px] font-bold tracking-[0.18em] uppercase text-[#F57C20] mb-3">{admin ? 'Admin · ' : ''}{title}</p>
    {children}
  </div>
);
